import { IgenomicsAction } from '../../core/interfaces/genomics-action.interface';
import { GeneralStoreEntity } from '../../core/entities/general-store.entity';
import { AGeneralActionCreator } from '../../core/classes/general-action-creator.abstract';
import { IDefinition } from '../interfaces/definition.interface';
import {IResource} from "@ispm/core/interfaces/resource.interface";

export abstract class ConfigurationActionCreator extends AGeneralActionCreator{
  constructor(payload: IResource | StartFetchingPayload | clearResourcePayload){
    if(payload) {
    const actionPayload = (<StartFetchingPayload> payload).configurationType || (<clearResourcePayload> payload).resourceToClear
      ? payload
      : {resource: payload as IResource, resourceType: (<IResource>  payload).resourceType};
    super(actionPayload);
  }else{
      super(payload);
    }
}
}

export enum ConfigurationActions {
  StartFetching = '[ConfigurationActions] StartFetching',
  Set = '[ConfigurationActions] Set',
  Reset = '[ConfigurationActions] Reset',
  Clear = '[ConfigurationActions] Clear'
}

export interface StartFetchingPayload {
  configurationType: string;
  configurationId: string;
}

export interface clearResourcePayload {
  resourceToClear: string;
}

export class StartFetchingConfigurationAction extends ConfigurationActionCreator {
  readonly type = ConfigurationActions.StartFetching;

  constructor(payload: StartFetchingPayload) {
    super(payload);
  }
}


export class SetConfigurationAction extends ConfigurationActionCreator {
  readonly type = ConfigurationActions.Set;

  constructor(payload: IResource) {
    super(
     payload
    );
  }
}

export class ClearConfigurationAction extends ConfigurationActionCreator {
  //Clears a certain configuration item
  readonly type = ConfigurationActions.Clear;

  constructor(resourceType: string) {
    super(
      {resourceToClear: resourceType}
    );
  }
}

export class ResetConfigurationAction extends ConfigurationActionCreator {
  readonly type = ConfigurationActions.Reset;

  constructor() {
    super(null);
  }
}

export type TConfigurationActions = StartFetchingConfigurationAction | SetConfigurationAction | ResetConfigurationAction | ClearConfigurationAction;
